import { useEffect, useMemo, useState, useCallback } from "react";
import { GetAllOrder, markAsDelivered } from "../../services/orderService";
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule } from "ag-grid-community";
import CommonMessage from "../../common/CommonMessage";


//import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { createShipment } from "../../services/shipment";
import HeaderCheckbox from "../../common/HeaderCheckbox";
import CommonGridHeader from "../../common/CommonGridHeader";
import CustomDateRange from "../../utils/CustomDateRange";
import { useNavigate } from "react-router-dom";

const modules = [AllCommunityModule];
const today = new Date().toISOString().split("T")[0];
const BulkShip = () => {
    const userid = localStorage.getItem("userid");
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [allRows, setAllRows] = useState([]);
    const [expandedRows, setExpandedRows] = useState({});
    const [error, setErrors] = useState("");
    const navigate = useNavigate();

    const loadOrders = useCallback(async (startDate = today, endDate = today) => {
        try {
            setLoading(true);

            const response = await GetAllOrder(
                Number(userid),
                startDate,
                endDate
            );

            if (response?.statusCode === 200 && response.success) {
                setErrors("");
                setAllRows(mapOrders(response.data));
            } else {
                setErrors(response?.message || "Something went wrong");
            }
        } catch (err) {
            setErrors(err.message);
        } finally {
            setLoading(false);
        }
    }, [userid]);

    useEffect(() => {
        loadOrders();
    }, [loadOrders]);
    const mapOrders = (orders) => {
        const rows = [];

        orders.forEach(order => {

            rows.push({
                id: order.id,
                orderType: order.orderType,
                dateCreated: order.dateCreated
                    ? new Date(order.dateCreated).toLocaleString()
                    : "",
                firstName: order.firstName,
                lastName: order.lastName,
                email: order.email,
                mobile: order.mobile,
                address: order.address,
                address2: order.address2,
                landMark: order.landMark,
                state: order.state,
                city: order.city,
                postalCode: order.postalCode,
                servicability: order.servicability,
                paymentName: order.payment?.name || "",
                diseaseName: order.issueDisease?.name || "",
                discount: order.discount,
                shiping: order.shiping,
                gTotal: order.gTotal,
                rowId: `parent-${order.id}`,
                type: "parent",
                hasChildren: order.getOrderItemDtos?.length > 0
            });

            order.getOrderItemDtos?.forEach((item, index) => {

                rows.push({
                    id: item.id,
                    productName: item.productName,
                    quantity: item.quantity,
                    priceAtPurchase: item.priceAtPurchase,
                    parentId: order.id,
                    rowId: `child-${order.id}-${index}`,
                    type: "child"
                });

            });

        });

        return rows;
    };


    //     useEffect(() => {
    //         const fetchData = async () => {
    //             try {
    //                 const response = await GetAllOrder(
    //             Number(userid),
    //             dateRange.startDate,
    //             dateRange.endDate
    //         );
    //                 if (
    //                     response?.statusCode === 200 &&
    //                     response?.success === true
    //                 ) {
    //                     setErrors("");

    //                     const rows = [];

    //                     response.data.forEach((order) => {

    //                         // ================= PARENT ROW =================
    //                         rows.push({
    //                             id: order.id,
    //                             orderType:order.orderType,
    //                             dateCreated: order.dateCreated
    //         ? new Date(order.dateCreated).toLocaleString()
    //         : "",
    //                             firstName: order.firstName,
    //                             lastName: order.lastName,
    //                             email: order.email,
    //                             mobile: order.mobile,
    //                             address: order.address,
    //                             address2: order.address2,
    //                             landMark: order.landMark,
    //                             state: order.state,
    //                             city: order.city,
    //                             postalCode: order.postalCode,
    // servicability:order.servicability,
    //                             paymentName:
    //                                 order.payment?.name || "",

    //                             diseaseName:
    //                                 order.issueDisease?.name || "",

    //                             discount: order.discount,
    //                             shiping: order.shiping,
    //                             gTotal: order.gTotal,

    //                             rowId: `parent-${order.id}`,

    //                             type: "parent",

    //                             hasChildren:
    //                                 order.getOrderItemDtos?.length > 0,
    //                         });

    //                         // ================= CHILD ROW =================
    //                         order.getOrderItemDtos?.forEach(
    //                             (item, index) => {
    //                                 rows.push({
    //                                     id: item.id,

    //                                     productName:
    //                                         item.productName,

    //                                     quantity:
    //                                         item.quantity,

    //                                     priceAtPurchase:
    //                                         item.priceAtPurchase,

    //                                     rowId: `child-${order.id}-${index}`,

    //                                     parentId: order.id,

    //                                     type: "child",
    //                                 });
    //                             }
    //                         );
    //                     });

    //                     setAllRows(rows);
    //                 } else {
    //                     setErrors(
    //                         response?.message ||
    //                         "Something went wrong"
    //                     );
    //                 }
    //             } catch (error) {
    //                 console.log(error);

    //                 setErrors(
    //                     error.message ||
    //                     "Something went wrong"
    //                 );
    //             }
    //         };

    //         fetchData();
    //     }, [userid]);

    // Expand / Collapse
    const toggleExpand = useCallback((id) => {
        setExpandedRows((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    }, []);

    // Visible Rows
    const rowData = useMemo(() => {
        return allRows.filter((row) => {
            if (row.type === "parent") return true;

            return expandedRows[row.parentId];
        });
    }, [allRows, expandedRows]);

    // Expand Button Renderer
    const ExpandCell = useCallback(
        (props) => {
            const row = props.data;

            if (
                row.type === "child" ||
                !row.hasChildren
            ) {
                return null;
            }

            return (
                <button
                    onClick={() =>
                        toggleExpand(row.id)
                    }
                    style={{
                        border: "none",
                        background: "transparent",
                        cursor: "pointer",
                        fontSize: "14px",
                        fontWeight: "bold",
                    }}
                >
                    {expandedRows[row.id]
                        ? "−"
                        : "+"}
                </button>
            );
        },
        [expandedRows, toggleExpand]
    );
    const [selectedOrderIds, setSelectedOrderIds] = useState([]);
    const CheckboxCellRenderer = useCallback(
        (props) => {
            const row = props.data;

            if (row.type !== "parent") {
                return null;
            }

            const checked = selectedOrderIds.includes(row.id);

            return (
                <input
                    type="checkbox"
                    checked={checked}
                    onChange={(e) => {
                        if (e.target.checked) {
                            setSelectedOrderIds((prev) =>
                                prev.includes(row.id) ? prev : [...prev, row.id]
                            );
                        } else {
                            setSelectedOrderIds((prev) =>
                                prev.filter((id) => id !== row.id)
                            );
                        }
                    }}
                />
            );
        },
        [selectedOrderIds]
    );
    const EditButtonRenderer = useCallback(
            (props) => {
                const row = props.data;
    
                if (row.type !== "parent") {
                    return null;
                }
    
                return (
                    <button
                        className="btn btn-sm btn-primary"
                        onClick={() => navigate(`/orders/edit/${row.id}`)}
                    >
                        Edit
                    </button>
                );
            },
            [navigate]
        );
    const columnDefs = useMemo(
        () => [
             {
                field: "__edit",
                headerName: "Action",
                width: 90,
                sortable: false,
                filter: false,
                pinned: "left",
                cellRenderer: EditButtonRenderer,
            },
            {
                field: "__select",
                headerName: "",
                width: 50,
                sortable: false,
                filter: false,
                pinned: "left",
                cellRenderer: CheckboxCellRenderer,
                headerComponent: HeaderCheckbox,
            },
            {
                field: "__expand",
                headerName: "",
                width: 40,
                cellRenderer: ExpandCell,
                sortable: false,
                filter: false,
            },

            {
                field: "id",
                headerName: "ID",
                width: 80,
            },
            {
                field: "dateCreated",
                headerName: "Date Created",
                width: 160,
            },
            { field: "orderType", headerName: "Order Type", width: 150 },
            {
                field: "firstName",
                headerName: "Customer Name",
                width: 120,

                valueGetter: (params) => {
                    if (
                        params.data.type ===
                        "parent"
                    ) {
                        return `${params.data.firstName} ${params.data.lastName}`;
                    }

                    return "Order Item";
                },

                cellStyle: (params) => ({
                    paddingLeft:
                        params.data.type ===
                            "child"
                            ? "40px"
                            : "10px",

                    fontWeight:
                        params.data.type ===
                            "parent"
                            ? "bold"
                            : "normal",
                }),
            },

            {
                field: "email",
                headerName: "Email",
                //flex: 1,
                width: 140,

                valueGetter: (params) =>
                    params.data.type ===
                        "parent"
                        ? params.data.email
                        : "",
            },

            {
                field: "mobile",
                headerName: "Mobile",
                width: 140,

                valueGetter: (params) =>
                    params.data.type ===
                        "parent"
                        ? params.data.mobile
                        : "",
            },

            {
                field: "address",
                headerName: "Address",
                //flex: 1,
                width: 200,

                valueGetter: (params) =>
                    params.data.type ===
                        "parent"
                        ? params.data.address
                        : "",
            },
            {
                field: "state",
                headerName: "State",
                width: 100,

                valueGetter: (params) =>
                    params.data.type ===
                        "parent"
                        ? params.data.state
                        : "",
            },
            {
                field: "city",
                headerName: "City",
                width: 130,

                valueGetter: (params) =>
                    params.data.type ===
                        "parent"
                        ? params.data.city
                        : "",
            },

            {
                field: "postalCode",
                headerName: "Pincode",
                width: 130,

                valueGetter: (params) =>
                    params.data.type ===
                        "parent"
                        ? params.data.postalCode
                        : "",
            },
            {
                field: "servicability",
                headerName: "Servicability",
                width: 130,

                valueGetter: (params) =>
                    params.data.type ===
                        "parent"
                        ? params.data.servicability
                        : "",
            },

            {
                field: "paymentName",
                headerName: "Payment",
                width: 130,

                valueGetter: (params) =>
                    params.data.type ===
                        "parent"
                        ? params.data.paymentName
                        : "",
            },

            {
                field: "diseaseName",
                headerName: "Disease",
                width: 170,

                valueGetter: (params) =>
                    params.data.type ===
                        "parent"
                        ? params.data.diseaseName
                        : "",
            },

            {
                field: "discount",
                headerName: "Discount",
                width: 120,

                valueGetter: (params) =>
                    params.data.type ===
                        "parent"
                        ? params.data.discount
                        : "",
            },

            {
                field: "shiping",
                headerName: "Shipping",
                width: 120,

                valueGetter: (params) =>
                    params.data.type ===
                        "parent"
                        ? params.data.shiping
                        : "",
            },

            {
                field: "gTotal",
                headerName: "Grand Total",
                width: 150,

                valueGetter: (params) =>
                    params.data.type ===
                        "parent"
                        ? params.data.gTotal
                        : "",
            },

            // ================= CHILD ROW DATA =================

            {
                field: "productName",
                headerName: "Product",
                width: 180,

                valueGetter: (params) =>
                    params.data.type ===
                        "child"
                        ? params.data.productName
                        : "",
            },

            {
                field: "quantity",
                headerName: "Qty",
                width: 100,

                valueGetter: (params) =>
                    params.data.type ===
                        "child"
                        ? params.data.quantity
                        : "",
            },

            {
                field: "priceAtPurchase",
                headerName: "Price",
                width: 120,

                valueGetter: (params) =>
                    params.data.type ===
                        "child"
                        ? params.data.priceAtPurchase
                        : "",
            },
        ],
        [ExpandCell, CheckboxCellRenderer,EditButtonRenderer]
    );

    const buildShipmentPayload = (orderId, courierId) => {
        const order = allRows.find(
            (x) => x.type === "parent" && x.id === orderId
        );

        if (!order) {
            return null;
        }

        const items = allRows
            .filter(
                (x) =>
                    x.type === "child" &&
                    x.parentId === orderId
            )
            .map((item) => ({
                id: item.id,
                productName: item.productName,
                qty: item.quantity,
                price: item.priceAtPurchase,
            }));

        return {
            courierMasterId: courierId,
            orderId: order.id.toString(),
            customerName: `${order.firstName} ${order.lastName}`,
            mobile: order.mobile,
            address: order.address,
            address2: order.address2 || "",
            city: order.city,
            state: order.state || "",
            pincode: order.postalCode,
            weight: 1,
            length: 1,
            width: 1,
            height: 1,
            orderAmount: order.gTotal,
            isCod:
                order.paymentName?.toLowerCase() ===
                "cod",
            itemDtos: items,
        };
    };

    const [open, setOpen] = useState(false);
    const handleAction = async (
        action,
        courierId
    ) => {
        if (selectedOrderIds.length === 0) {
            alert("Please select at least one order");
            return;
        }
        setLoading(true);
        setMessage("");
        try {
            for (const orderId of selectedOrderIds) {

                setMessage(`Generating shipment for Order ${orderId}...`);

                const payload = buildShipmentPayload(orderId, courierId);
                const response = await createShipment(payload);

                if (response?.statusCode === 200) {

                    setMessage(
                        `Order ${orderId}: ${response.message || "Shipment generated successfully"}`
                    );

                    setAllRows(prev =>
                        prev.filter(
                            row =>
                                row.id !== orderId &&
                                row.parentId !== orderId
                        )
                    );

                    setSelectedOrderIds(prev =>
                        prev.filter(id => id !== orderId)
                    );

                } else {

                    setMessage(
                        `Order ${orderId}: ${response?.message || "Shipment failed"}`
                    );
                }
            }

            setOpen(false);

        } catch (err) {
            console.error(err);
            setMessage("Something went wrong.");
        } finally {
            setLoading(false);   // Hide loader after all orders complete
        }
    };

    const handleMarkAsDlvrdAction = async () => {
        if (selectedOrderIds.length === 0) {
            alert("Please select at least one order");
            return;
        }
        setLoading(true);
        setMessage("");

        try {
            for (const orderId of selectedOrderIds) {

                setMessage(`Generating shipment for Order ${orderId}...`);

                const response = await markAsDelivered(orderId);



                if (response?.statusCode === 200) {
                    setMessage(response?.message || "Order Delivered successfully");
                    setErrors("");

                    setAllRows(prev =>
                        prev.filter(
                            row =>
                                row.id !== orderId &&
                                row.parentId !== orderId
                        )
                    );

                    setSelectedOrderIds(prev =>
                        prev.filter(id => id !== orderId)
                    );
                } else {
                    setMessage(
                        `Order ${orderId}: ${response?.message || "Shipment failed"}`
                    );
                }
            }

            setOpen(false);
        } catch (err) {
            console.error(err);
            setMessage("Something went wrong.");
        } finally {
            setLoading(false);   // Hide loader after all orders complete
        }
    };


    //implement header fields
    const defaultFields = useMemo(
        () =>
            columnDefs
                .map(col => col.field)
                .filter(Boolean),
        [columnDefs]
    );
    const [selectedFields, setSelectedFields] = useState(defaultFields);
    useEffect(() => {
        setSelectedFields(defaultFields);
    }, [defaultFields]);

    const handleFieldChange = (field) => {
        setSelectedFields(prev =>
            prev.includes(field)
                ? prev.filter(x => x !== field)
                : [...prev, field]
        );
    };
    const handleReset = () => {
        setSelectedFields(defaultFields);
    };
    const visibleColumnDefs = useMemo(() => {
        return columnDefs.filter(col => selectedFields.includes(col.field));
    }, [columnDefs, selectedFields]);
    // end here

    const [dateRange, setDateRange] = useState({
        startDate: today,
        endDate: today,
    });
    const handleDateChange = ({ startDate, endDate }) => {
        setDateRange({
            startDate,
            endDate,
        });
    };

    const handleSearch = () => {
        loadOrders(
            dateRange.startDate,
            dateRange.endDate
        );
    };


    return (
        <div className="container-fluid py-3">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h4>Bulk Order Shipment</h4>
            </div>
            <CommonGridHeader
                fields={columnDefs
                    .filter(col => col.field)
                    .map(col => ({
                        key: col.field,
                        label: col.headerName || col.field
                    }))
                }
                selectedFields={selectedFields}
                onFieldChange={handleFieldChange}
                onReset={handleReset}
            />
            <CustomDateRange
                startDate={dateRange.startDate}
                endDate={dateRange.endDate}
                onChange={handleDateChange}
            />

            <button
                className="btn btn-primary"
                onClick={handleSearch}
                disabled={loading}
            >
                {loading ? "Loading..." : "Search"}
            </button>
            <div className="mb-3">
                {message && <CommonMessage text={message} />}
            </div>
            <div className="position-relative">
                <button
                    className="btn btn-success"
                    disabled={loading}
                    onClick={() => setOpen(!open)}
                >
                    {loading ? "Generating..." : "Select Action"}
                </button>

                {open && (
                    <ul
                        className="dropdown-menu show"
                        style={{ position: "absolute" }}
                    >
                        <li>
                            <button
                                type="button"
                                className="dropdown-item"
                                disabled={loading}
                                onClick={() => handleAction(
                                    "EKart",
                                    1
                                )}
                            >
                                EKart
                            </button>
                        </li>
                        <li>
                            <button
                                type="button"
                                className="dropdown-item"
                                disabled={loading}
                                onClick={() => handleAction(
                                    "Delhivery",
                                    2
                                )}
                            >
                                Delhivery
                            </button>
                        </li>
                        <li>
                            <button
                                type="button"
                                className="dropdown-item"
                                onClick={() => handleAction(
                                    "SelloShip PostPaid",
                                    3
                                )}
                            >
                                SelloShip PostPaid
                            </button>
                        </li>
                        <li>
                            <button
                                type="button"
                                className="dropdown-item"
                                onClick={() => handleMarkAsDlvrdAction()}
                            >
                                Mark as Delivered
                            </button>
                        </li>

                    </ul>
                )}
            </div>
            <div
                className="ag-theme-quartz"
                style={{
                    width: "100%",
                }}
            >
                <AgGridReact
                    modules={modules}
                    rowData={rowData}
                    columnDefs={visibleColumnDefs}
                    context={{
                        allRows,
                        selectedOrderIds,
                        setSelectedOrderIds,
                    }}
                    pagination={true}
                    paginationPageSize={10}
                    rowHeight={45}
                    animateRows={true}
                    domLayout="autoHeight"
                    getRowId={(params) =>
                        params.data.rowId
                    }

                    getRowStyle={(params) => {
                        if (params.data.type === "child") {
                            return {
                                background: "#f8f9fa",
                            };
                        }
                    }}
                />
            </div>

            {error && <CommonMessage text={error} />}
        </div>
    );
};

export default BulkShip;